import qs from 'qs';

import { axiosPrivate } from 'app/utils';
import helpers from '../helpers';

export default {
  async getInactivePatients({ pharmacyId }) {
    const response = await axiosPrivate.get(`/pharmacies/${pharmacyId}/inactive-patients`);

    if (response.data.error) helpers.throwError(response.data.error);
    return response.data;
  },

  async getUnusedInvites(pharmacyId, paginationOptions) {
    const queryString = paginationOptions ? qs.stringify(paginationOptions) : null;
    const response = await axiosPrivate.get(
      `/pharmacies/${pharmacyId}/unused-patient-invites${queryString ? `?${queryString}` : ''}`
    );

    if (response.data.error) helpers.throwError(response.data.error);
    return response.data;
  },

  async getUnassignedPatients({ pharmacyId }) {
    const response = await axiosPrivate.get(`/pharmacies/${pharmacyId}/unassigned-patients`);

    if (response.data.error) helpers.throwError(response.data.error);
    return response.data;
  },

  async updatePatientInvite(pharmacyId, inviteId, payload) {
    const response = await axiosPrivate.put(
      `/pharmacies/${pharmacyId}/invite/${inviteId}`,
      payload
    );

    if (response.data.error) helpers.throwError(response.data.error);
    return response.data;
  },

  async updatePatient(pharmacyId, patientId, payload) {
    const response = await axiosPrivate.put(
      `/pharmacies/${pharmacyId}/patient/${patientId}`,
      payload
    );

    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },

  async getPharmacyPatient({ pharmacyId, patientId }) {
    const response = await axiosPrivate.get(`/pharmacies/${pharmacyId}/patient/${patientId}`);

    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },

  async createPatient(pharmacyId, payload) {
    const response = await axiosPrivate.post(`/pharmacies/${pharmacyId}/patient`, payload);

    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },

  async searchDMRPatient(pharmacyId, name) {
    const queryString = qs.stringify({ name });
    const response = await axiosPrivate.get(
      `/pharmacies/${pharmacyId}/dmr-patient-search?${queryString}`
    );

    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },

  async getInactiveDMRPatients(pharmacyId) {
    const response = await axiosPrivate.get(`/pharmacies/${pharmacyId}/dmr-patients/inactive`);

    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },

  async getPatientMedicines({ pharmacyId, patientId }) {
    const response = await axiosPrivate.get(
      `/pharmacies/${pharmacyId}/patients/${patientId}/medicines`
    );

    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },

  async addMedicineToPatient({ pharmacyId, patientId, payload }) {
    const response = await axiosPrivate.post(
      `/pharmacies/${pharmacyId}/patients/${patientId}/medicines`,
      payload
    );

    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },

  async removeMedicineFromPatient({ pharmacyId, patientId, remedyId }) {
    const response = await axiosPrivate.delete(
      `/pharmacies/${pharmacyId}/patients/${patientId}/medicines/${remedyId}`
    );

    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },

  async createDigitalManagedRepeat({ pharmacyId, payload }) {
    const response = await axiosPrivate.post(`/pharmacies/${pharmacyId}/dmr`, payload);

    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },

  async updateDigitalManagedRepeat({ pharmacyId, orderScheduleId, payload }) {
    const response = await axiosPrivate.put(
      `/pharmacies/${pharmacyId}/dmr/${orderScheduleId}`,
      payload
    );

    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },

  async bulkApproveDigitalManagedRepeats({ pharmacyId, dmrIds }) {
    const response = await axiosPrivate.put(`/pharmacies/${pharmacyId}/dmr-bulk-approve`, {
      digital_managed_repeat_ids: dmrIds,
    });

    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },

  async getDMRStats({ pharmacyId }) {
    const response = await axiosPrivate.get(`/pharmacies/${pharmacyId}/dmr-stats`);

    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },

  async getActiveDMRStats({ pharmacyId, periods }) {
    const queryString = qs.stringify({ periods });
    const response = await axiosPrivate.get(
      `/pharmacies/${pharmacyId}/dmr-stats/active?${queryString}`
    );

    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },

  async getActiveDMRs({ pharmacyId, filters }) {
    const queryString = filters ? `?${qs.stringify(filters)}` : '';
    const response = await axiosPrivate.get(`/pharmacies/${pharmacyId}/active-dmr${queryString}`);

    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },

  async searchActiveDMRByName({ pharmacyId, name, page, limit }) {
    const queryString = qs.stringify({ name, ...(page && { page }), ...(limit && { limit }) });
    const response = await axiosPrivate.get(
      `/pharmacies/${pharmacyId}/active-dmr/search?${queryString}`
    );

    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },

  async getSingleDMR({ pharmacyId, orderScheduleId }) {
    const response = await axiosPrivate.get(`/pharmacies/${pharmacyId}/dmr/${orderScheduleId}`);

    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },

  async deleteDMR({ pharmacyId, orderScheduleId }) {
    const response = await axiosPrivate.delete(`/pharmacies/${pharmacyId}/dmr/${orderScheduleId}`);

    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },
};
